module.exports = __webpack_public_path__ + "img/2x.a03e3af.jpg";